import { render } from "./signup-step-supporter-details.vue?vue&type=template&id=f08cad86&scoped=true&ts=true"
import script from "./signup-step-supporter-details.vue?vue&type=script&lang=ts"
export * from "./signup-step-supporter-details.vue?vue&type=script&lang=ts"

import "./signup-step-supporter-details.vue?vue&type=style&index=0&id=f08cad86&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f08cad86"]])

export default __exports__